module.exports = __webpack_public_path__ + "files/3f0369a9edc9becedfa6af01fc6708bd.png";